<div class="appointment-container">
	<div #search>
		<select #searchDD (change)="whatValue()">
			<option value="1">Before</option>
			<option value="2">After</option>
			<option value="3">Between</option>
		</select>
	</div>
	<div #singleSlider class="range-slider">
		<div class="rs-label-containter"><span #rsBullet class="rs-label">0</span></div>
		<!--  in class above <span class="rs-label-day">AM</span> -->
		<input (input)="showSliderValue()" #rsRangeLine class="rs-range" type="range" value="0" min="0" max="17" />

		<div class="box-minmax"><span>09:00</span><span>17:30</span></div>
		<h3>
			Appointment Time: <br />
			{{ text }}
		</h3>
	</div>

	<div #multipleSlider class="wrap">
		<section class="range-slider">
			<input #slider1 id="r" value="0" min="1" max="18" step="1" type="range" [(ngModel)]="sldr1" (ngModelChange)="sliderOneChange($event)" list="dl" />
			<input #slider2 id="r" value="18" min="1" max="18" step="1" type="range" [(ngModel)]="sldr2" (ngModelChange)="sliderTwoChange($event)" list="dl" />
		</section>
		<div class="box-minmax between"><span>09:00</span><span>17:30</span></div>
		<h3>
			Appointment Time: <br />
			Between {{ this.beginTime }} - {{ this.endTime }}
		</h3>
	</div>
</div>
